import React from 'react';
import { Row, Col } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Backdrop } from '..';
import AdWidgetDrawer from './style';
import Detail from './detail';
import { getLastSubId } from '../../utils/commonUtils';

const Index = (props) => {
  const { ad, showAdDetail, setShowAdDetail, integrationLocalData } = props;

  const onCloseAdDetail = () => {
    setShowAdDetail(false);
  };

  return (
    <>
      <Backdrop show={showAdDetail} onClickBackdrop={onCloseAdDetail} />
      <AdWidgetDrawer show={showAdDetail}>
        <Row
          gutter={24}
          wrap={false}
          align="middle"
          justify="space-between"
          className="component_ad_detail_header"
        >
          <Col flex="1">
            <Row gutter={[4, 4]}>
              <Col span={24} className="font-paragraph_medium black4">
                Ad Detail
              </Col>
              <Col span={24} className="font-subtitle1_medium black1">
                {ad?.name}
                <div className="font-paragraph_medium black2">
                  {getLastSubId(ad?.id)}
                </div>
              </Col>
            </Row>
          </Col>
          <Col>
            <CloseOutlined onClick={onCloseAdDetail} />
          </Col>
        </Row>
        {showAdDetail && (
          <Detail adId={ad?.id} integrationLocalData={integrationLocalData} />
        )}
      </AdWidgetDrawer>
    </>
  );
};

export default Index;
